import type { PortableTextTypeComponent } from '@portabletext/react';

import type { VimeoSubtitleLanguageCodes } from '@helsenorge/core-cms/videospiller/constants';

import VideoMatriseBlockComponent, { type VideoMatriseBlockProps } from './VideoMatriseBlock';

export interface VideoMatriseBlockPortableText extends VideoMatriseBlockProps {
  _type: 'VideoMatriseBlockPortableText';
  subtitleLanguageCode: VimeoSubtitleLanguageCodes;
}

const VideoMatriseBlockPortableText: PortableTextTypeComponent<VideoMatriseBlockPortableText> = ({ value }) => {
  return <VideoMatriseBlockComponent {...value} />;
};

export default VideoMatriseBlockPortableText;
